import React from "react";

import HeaderAccountSectionLoggedIn from "./HeaderAccountSectionLoggedIn";
import HeaderAccountSectionLoggedOut from "./HeaderAccountSectionLoggedOut";

import { useAuthState } from "../../../contexts/Auth/context";

const NavAccountInfo = () => {
  const { isLoggedIn } = useAuthState();

  return isLoggedIn ? (
    <HeaderAccountSectionLoggedIn />
  ) : (
    <HeaderAccountSectionLoggedOut />
  );
};

export default React.memo(NavAccountInfo);
